import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PromoWrapper = styled.div<{ isAvailable?: boolean }>`
  width: inherit;
  flex-direction: row;
  flex-wrap: nowrap;
  background-color: ${COLORS.BgSurface};
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 8px;
  display: ${p => p.isAvailable ? 'flex' : 'none'};
  ${FONTS.XS};

  a {
      color: ${COLORS.TextPrimary};
      ${FONTS.MediumXS};
      position: relative;
  }
`;

export const PromoTextBlock = styled.div<{ isImg?: string }>`
  flex-wrap: wrap;
  flex-direction: column;
  margin-left: ${p => p.isImg ? '8px' : '0'};
  margin-top: ${p => p.isImg ? '8px' : '0'};
`;

export const TextLabelBlock = styled.div`
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
`;

export const PromoTitle = styled.div<{ isPromoted?: boolean }>`
  transition: color 0.3s ease;
  display: inline-block;
  ${FONTS.MediumS};
  color: ${p => p.isPromoted ? COLORS.Logo : COLORS.TextPrimary};

  span {
      vertical-align: middle;
  }

  &:hover {
      color: ${COLORS.Logo};
  }
`;

export const PromoDesc = styled.p<{ isImg?: string }>`
  ${p => p.isImg ? FONTS.XXS : FONTS.XS};
  color: ${COLORS.TextInfo};
  white-space: pre-wrap;
  margin-top: 4px;
  padding: 0 !important;
`;

export const PromoMore = styled.p`
  ${FONTS.XS};
  white-space: pre-wrap;
  align-items: center;
  display: flex;
  margin-top: 8px;
  padding: 0 !important;
  justify-content: flex-start !important;

  span {
      ${FONTS.MediumXS};
      color: ${COLORS.Logo};
  }

  img{
      margin-left: 4px; 
      color: ${COLORS.Logo};
  }
`;

export const PromoImg = styled.div`
  border-radius: ${BorderRadius.labelRadius};
  width: 100%;
  height: 100%;

  img{
      width: 136px;
      height: 134px;
      border-radius: ${BorderRadius.labelRadius};
      object-fit: cover;
      image-rendering: -webkit-optimize-contrast;
  }
`;

export const Label = styled.span<{ bgColor?: string, colorText?: string }>`
  background-color: ${p => p.bgColor};
  width: auto;
  padding: 2px 8px;
  margin-right: 8px;
  height: 20px;
  border-radius: ${BorderRadius.labelRadius};
  vertical-align: baseline;
  margin-left: 6px;
  color: ${p => p.colorText};
  ${FONTS.MediumXXS};
`;
